"use client";

import { useState } from "react";
import { DemoBookingModal } from "@/components/DemoBookingModal";

interface UseDemoModalProps {
  title?: string;
  description?: string;
}

export const useDemoModal = (props?: UseDemoModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const DemoModal = () => (
    <DemoBookingModal
      open={isOpen}
      onOpenChange={setIsOpen}
      title={props?.title}
      description={props?.description}
    />
  );

  return {
    openModal,
    closeModal,
    DemoModal,
    isOpen,
  };
};
